import * as React from "react";
import {ISymptom} from "@curefit/care-common";
import {LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import {PatientSymptomViewProps} from "../../components/patient/view/PatientSymptomView";
import IChiefComplaint from "../../models/IChiefComplaint";
import {PatientComplaintsEditorProps} from "../../components/patient/edit/PatientComplaintsEditor";
import {PatientIllnessEditorProps} from "../../components/patient/edit/PatientIllnessesEditor";
import {SourceConstants, SymptomTypes} from "../../utils/AppConstants";
import IEditedBy from "../../models/IEditedBy";
import {PatientIllnessViewProps} from "../../components/patient/view/PatientIllnessView";

/**
 * Created by aditya on 26/02/18.
 */
export interface PhysioChiefComplaintsEditViewContProps {
    editedBy: IEditedBy,
    patientId: number,
    patientChiefComplaints: IChiefComplaint,
    patientHopis: string,
    displayMode?: EditViewDisplayMode,
    fetchPatientChiefComplaints?: (patientId: number) => any,
    savePatientChiefComplaints?: (patientId: number, patientChiefComplaint: IChiefComplaint) => any,
    fetchStaticSymptoms?: (input: string) => Promise<any>,
    suggestions: {[key: string]: any}
}

export interface PhysioChiefComplaintsEditViewContState {
    updatedComplaints: {item: ISymptom}[],
    updatedIllnesses: {item: ISymptom}[],
    updatedHopis: {item: string},
    isPatientChiefComplaintsDataLoaded: LOADING_STATE
}

class PhysioChiefComplaintsEditViewCont extends React.Component<PhysioChiefComplaintsEditViewContProps, PhysioChiefComplaintsEditViewContState> {

    constructor(props: PhysioChiefComplaintsEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: PhysioChiefComplaintsEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedComplaintsFromProps = (props: PhysioChiefComplaintsEditViewContProps): {item: ISymptom}[] => {
        let currUpdatedComplaints: {item: ISymptom}[] = [];
        _.map(props.patientChiefComplaints.complaints, function(symptom){
            let clonePatientComplaints = Object.assign({}, symptom);
            currUpdatedComplaints.push({item: clonePatientComplaints});
        });
        return currUpdatedComplaints;
    }

    getUpdatedIllnessesFromProps = (props: PhysioChiefComplaintsEditViewContProps): {item: ISymptom}[] => {
        let currUpdatedComplaints: {item: ISymptom}[] = [];
        _.map(props.patientChiefComplaints.illness, function(symptom){
            let clonePatientComplaints = Object.assign({}, symptom);
            currUpdatedComplaints.push({item: clonePatientComplaints});
        });
        return currUpdatedComplaints;
    }

    getUpdatedHopisFromProps = (props: PhysioChiefComplaintsEditViewContProps): {item: string} => {
        let currUpdatedIllnesses: {item: string} = null;
        currUpdatedIllnesses = {item: props.patientHopis }
        return currUpdatedIllnesses;
    }

    getStateFromProps = (props: PhysioChiefComplaintsEditViewContProps) => {
        let currState: PhysioChiefComplaintsEditViewContState = {
            updatedComplaints: [],
            updatedIllnesses: [],
            updatedHopis: null,
            isPatientChiefComplaintsDataLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( _.isNull(props.patientChiefComplaints.complaints) ||  _.isNull(props.patientChiefComplaints.illness) ) {
            props.fetchPatientChiefComplaints(this.props.patientId);
            currState.isPatientChiefComplaintsDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedComplaints = [];
            if (!_.isEmpty(props.patientChiefComplaints.complaints)) {
                _.map(props.patientChiefComplaints.complaints, function(patientComplaint){
                    let clonePatientComplaints = Object.assign({}, patientComplaint);
                    currState.updatedComplaints.push({item: clonePatientComplaints});
                });
            }

            currState.updatedIllnesses = [];
            if (!_.isEmpty(props.patientChiefComplaints.complaints)) {
                _.map(props.patientChiefComplaints.illness, function(patientComplaint){
                    let clonePatientComplaints = Object.assign({}, patientComplaint);
                    currState.updatedIllnesses.push({item: clonePatientComplaints});
                });
            }

            currState.updatedHopis = null;
            if (!_.isEmpty(props.patientHopis)) {
                currState.updatedHopis = {item: props.patientHopis};
            }
            currState.isPatientChiefComplaintsDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getComplaintsEditViewTemplateProps = () => {
        let patientSymptomsViewProps: PatientSymptomViewProps = {
            symptoms: this.props.patientChiefComplaints.complaints
        }
        let patientSymptomsEditorProps: PatientComplaintsEditorProps = {
            updatedComplaints: this.state.updatedComplaints,
            updateComplaints: this.updatePatientComplaints,
            fetchStaticSymptoms: this.props.fetchStaticSymptoms,
            suggestions: this.props.suggestions
        }
        return {"view": patientSymptomsViewProps, "edit": patientSymptomsEditorProps};
    }

    getIllnessesEditViewTemplateProps = () => {
        let patientSymptomsViewProps: PatientIllnessViewProps = {
            illness: this.props.patientChiefComplaints.illness
        }
        let patientSymptomsEditorProps: PatientIllnessEditorProps = {
            updatedIllnesses: this.state.updatedIllnesses,
            updateIllnesses: this.updatePatientIllnesses,
            fetchStaticSymptoms: this.props.fetchStaticSymptoms,
            updatedHopis: this.state.updatedHopis,
            updateHopi: this.updatePatientHopis
        }
        return {"view": patientSymptomsViewProps, "edit": patientSymptomsEditorProps};
    }

    updatePatientComplaints = (updatedComplaints: {item: ISymptom}[]) => {
        this.setState({updatedComplaints});
    }

    updatePatientIllnesses = (updatedIllnesses: {item: ISymptom}[]) => {
        this.setState({updatedIllnesses});
    }

    updatePatientHopis = (updatedHopis: {item: string}) => {
        this.setState({updatedHopis});
    }

    savePatientChiefComplaints = () => {
        let myInstance = this;
        let patientChiefComplaints: IChiefComplaint;
        let saveComplaintsList: ISymptom[] = this.getSaveObject().complaints;
        let saveIllnessList: ISymptom[] = this.getSaveObject().illness;
        if (saveComplaintsList.length > 0 || saveIllnessList.length > 0) {
            this.setState({isPatientChiefComplaintsDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            patientChiefComplaints = {illness: saveIllnessList, complaints: saveComplaintsList}
            this.props.savePatientChiefComplaints(this.props.patientId, patientChiefComplaints).then(function(){
                myInstance.setState({isPatientChiefComplaintsDataLoaded: LOADING_STATE.LOADED})
            });
        }
    }

    cancelComplaintsActionHandler = () => {
        this.setState({updatedComplaints: this.getUpdatedComplaintsFromProps(this.props)});
    }

    cancelIllnessesActionHandler = () => {
        this.setState({updatedIllnesses: this.getUpdatedIllnessesFromProps(this.props)});
    }

    getSaveObject = (): IChiefComplaint => {
        let myInstance = this;
        let chiefComplaint: IChiefComplaint;
        let complaintList: ISymptom[] = [];
        let illnessList: ISymptom[] = [];
        let editedBy = this.props.editedBy;
        _.map(this.state.updatedComplaints, function(updateSymptomItem: {item: ISymptom}){
            updateSymptomItem.item.type = SymptomTypes.CHIEF;
            updateSymptomItem.item.lastEditedPersonId = parseInt(editedBy.id);
            updateSymptomItem.item.personType = editedBy.role.toLowerCase();
            updateSymptomItem.item.source = SourceConstants.DOCSASPP;
            if (updateSymptomItem.item.id) delete updateSymptomItem.item.id;
            complaintList.push(updateSymptomItem.item);
        });
        _.map(this.state.updatedIllnesses, function(updateSymptomItem: {item: ISymptom}){
            updateSymptomItem.item.type = SymptomTypes.ASSOCIATED;
            updateSymptomItem.item.lastEditedPersonId = parseInt(editedBy.id);
            updateSymptomItem.item.personType = editedBy.role.toLowerCase();
            updateSymptomItem.item.source = SourceConstants.DOCSASPP;
            if (updateSymptomItem.item.id) delete updateSymptomItem.item.id;
            illnessList.push(updateSymptomItem.item);
        });
        chiefComplaint = {
            complaints: complaintList,
            illness: illnessList
        }
        return chiefComplaint;
    }

    getHopisSaveObject = (): string => {
        return !_.isEmpty(this.state.updatedHopis) ? this.state.updatedHopis.item : null;
    }

    isIllnessesFormDirty = (): boolean => {
        let status = false;
        _.map(this.state.updatedIllnesses, function(updatedIllnessItem: {item: ISymptom}){
            if (!ModelFactory.isValidSymptom(updatedIllnessItem.item)) {
                status = true;
                return false;
            }
        })
        return status;
    }

    isComplaintsFormDirty = (): boolean => {
        let status = false;
        _.map(this.state.updatedComplaints, function(updatedIllnessItem: {item: ISymptom}){
            if (!ModelFactory.isValidSymptom(updatedIllnessItem.item)) {
                status = true;
                return false;
            }
        })
        return status;
    }

    complaintsDirtyFormText = (): string => {
        let erronousRows: number[] = [];
        let longText = false;
        _.map(this.state.updatedComplaints, function(updateAllergyItem: {item: ISymptom}, index: number){
            if (!ModelFactory.isValidSymptom(updateAllergyItem.item)) {
                if (!_.isEmpty(updateAllergyItem.item.displayValue)
                    && updateAllergyItem.item.displayValue.length > 255)
                    longText = true;
                erronousRows.push(index + 1);
                return false;
            }
        })
        let errorText = longText ? "Too long text entered in Complaints. Try entering long texts in comments"
            : `Missing symptom name in row/(s) ${erronousRows.join(", ")}`;
        return errorText;
    }

    illnessesDirtyFormText = (): string => {
        let erronousRows: number[] = [];
        let longText = false;
        _.map(this.state.updatedIllnesses, function(updateAllergyItem: {item: ISymptom}, index: number){
            if (!ModelFactory.isValidSymptom(updateAllergyItem.item)) {
                if (!_.isEmpty(updateAllergyItem.item.displayValue)
                    && updateAllergyItem.item.displayValue.length > 255)
                    longText = true;
                erronousRows.push(index + 1);
                return false;
            }
        })
        let errorText = longText ? "Too long text entered in Illnesses. Try entering long texts in comments"
            : `Missing symptom name in row/(s) ${erronousRows.join(", ")}`;
        return errorText;
    }

    render() {
        let isSymptomDataLoaded =  this.state.isPatientChiefComplaintsDataLoaded === LOADING_STATE.LOADED;
        return (
            <div className="symptom-editview-cont">
                {
                    isSymptomDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Chief Complaints"} templateName={"physiocomplaints"}
                                  templateProps={this.getComplaintsEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientChiefComplaints}
                                  cancelActionHandler={this.cancelComplaintsActionHandler}
                                  displayMode={this.props.displayMode}
                    />
                }
                {
                    !isSymptomDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default PhysioChiefComplaintsEditViewCont